var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalBorders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11.129,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13.839,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.71,
    y: 13.839,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5.71,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.71,
    y: 3,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.419,
    y: 3,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.419,
    y: 13.839,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.419,
    y: 5.71,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8.419,
    y: 11.129,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11.129,
    y: 3,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13.839,
    y: 3,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 13.839,
    y: 5.71,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 13.839,
    y: 11.129,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 13.839,
    y: 13.839,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 11.129,
    y: 13.839,
    width: 1.161,
    height: 1.161,
    rx: 0.155,
    fill: "currentColor",
    opacity: 0.6
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8.419,
    width: 12,
    height: 1.161,
    rx: 0.4,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBorders);
export default __webpack_public_path__ + "static/media/horizontalBorders.a8a95e3780191cfd8117f522b5b51fda.svg";
export { ForwardRef as ReactComponent };